import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../config";
import CompanyHeader from "./CompanyHeader";

const CompanyProfile = () => {
  const [company, setCompany] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");

  const fetchCompany = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}settings/company/company-info`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setCompany(response.data.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, []);

  const SkeletonValue = ({ width = "70%" }) => (
    <div className="skeleton-box" style={{ width }}></div>
  );

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed">
      <div id="content" className="p-0">
        <CompanyHeader />

        <div className="profile-container" style={{ overflowX: "hidden" }}>
          <div className="row row-space-20">
            {/* COMPANY INFORMATION */}
            <div className="col-md-6">
              <table className="table table-profile">
                <thead>
                  <tr>
                    <th colSpan="2">COMPANY INFORMATION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="field">Email</td>
                    <td className="value">
                      {loading ? (
                        <SkeletonValue />
                      ) : (
                        <b>
                          <Link to={`mailto:${company.company_email}`}>
                            {company.company_email}
                          </Link>
                        </b>
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="field">Sales Phone No.</td>
                    <td className="value">
                      {loading ? <SkeletonValue width="50%" /> : <b>{company.sales_phone}</b>}
                    </td>
                  </tr>

                  <tr>
                    <td className="field">Research Phone No.</td>
                    <td className="value">
                      {loading ? <SkeletonValue width="50%" /> : <b>{company.research_phone}</b>}
                    </td>
                  </tr>

                  <tr>
                    <td className="field">Address</td>
                    <td className="value">
                      {loading ? <SkeletonValue width="90%" /> : <b>{company.company_address}</b>}
                    </td>
                  </tr>

                  <tr>
                    <td className="field">Home Video</td>
                    <td className="value">
                      {loading ? <SkeletonValue /> : <b>{company.home_video}</b>}
                    </td>
                  </tr>

                  <tr>
                    <td className="field">Philosophy Video</td>
                    <td className="value">
                      {loading ? (
                        <SkeletonValue />
                      ) : company.philosophy_video ? (
                        <a href={company.philosophy_video} target="_blank" rel="noopener noreferrer">
                          <b>View Video</b>
                        </a>
                      ) : (
                        <span className="text-muted">Not Set</span>
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="field">Philosophy Thumbnail</td>
                    <td className="value">
                      {loading ? (
                        <SkeletonValue width="40%" />
                      ) : company.philosophy_thumbnail ? (
                        <a href={company.philosophy_thumbnail} target="_blank" rel="noopener noreferrer">
                          <b>View Thumbnail</b>
                        </a>
                      ) : (
                        <span className="text-muted">Not Set</span>
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="field">Tax Percentage</td>
                    <td className="value">
                      {loading ? <SkeletonValue width="30%" /> : <b>{company.tax_percentage}</b>}
                    </td>
                  </tr>

                  <tr>
                    <td className="field">Office Location</td>
                    <td className="value">
                      {loading ? <SkeletonValue width="80%" /> : <b>{company.locationmap}</b>}
                    </td>
                  </tr>

                  <tr>
                    <td className="field">App Home Description</td>
                    <td className="value">
                      {loading ? (
                        <SkeletonValue width="100%" />
                      ) : (
                        <div
                          style={{
                            wordBreak: "break-word",
                            whiteSpace: "pre-wrap",
                            overflowWrap: "break-word",
                            maxWidth: "100%",
                          }}
                        >
                          <b>{company.app_desc}</b>
                        </div>
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="field">Risk Disclosure Document</td>
                    <td className="value">
                      {loading ? (
                        <SkeletonValue width="40%" />
                      ) : (
                        company.risk_dis_doc && (
                          <Link to={company.risk_dis_doc} target="_blank" download>
                            Download
                          </Link>
                        )
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* CONTACT US */}
            <div className="col-md-6">
              <table className="table table-profile">
                <thead>
                  <tr>
                    <th colSpan="2">Contact Us</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["Facebook Link", company.facebook_link],
                    ["Instagram Link", company.instagram_link],
                    ["Twitter Link", company.twitter_link],
                    ["LinkedIn Link", company.linkedin_link],
                    ["Skype Link", company.skype_link],
                    ["WhatsApp Link", company.whatsapp_link],
                    ["YouTube Link", company.youtube_link],
                    ["Telegram Link", company.telegram_link],
                  ].map(([label, value], index) => (
                    <tr key={index}>
                      <td className="field">{label}</td>
                      <td className="value">
                        {loading ? (
                          <SkeletonValue />
                        ) : (
                          <b>
                            <Link to={value} target="_blank">
                              {value}
                            </Link>
                          </b>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyProfile;
